module.exports = __webpack_public_path__ + "static/media/store.ba58df77.svg";